import "./BodywerksBlogListingPage.module.css";
import Header from "@/reusable_sections/Header";
import ServicesOverview from "./sections/ServicesOverview";
import LatestArticles from "./sections/LatestArticles";
import SidebarWidgets from "./sections/SidebarWidgets";
import JoinTheWellnessCircle from "./sections/JoinTheWellnessCircle";
import Footer from "@/reusable_sections/Footer";
export default function BodywerksBlogListingPagePage() {
  return <div>
      <Header />
      <ServicesOverview />
      <LatestArticles />
      <SidebarWidgets />
      <JoinTheWellnessCircle />
      <Footer />
    </div>;
}